"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderHistoryItemResponseToJSON = exports.OrderHistoryItemResponseFromJSONTyped = exports.OrderHistoryItemResponseFromJSON = exports.instanceOfOrderHistoryItemResponse = exports.OrderHistoryItemResponseStageEnum = exports.OrderHistoryItemResponsePatientResultStatusLabelEnum = exports.OrderHistoryItemResponsePatientResultStatusEnum = exports.OrderHistoryItemResponseHcpTestTypeEnum = exports.OrderHistoryItemResponseHcpStageLabelEnum = exports.OrderHistoryItemResponseHcpBillingLabelEnum = void 0;
var runtime_1 = require("../runtime");
var OrderHistoryConceptResponse_1 = require("./OrderHistoryConceptResponse");
var OrderHistoryItemHcpPreferencesResponse_1 = require("./OrderHistoryItemHcpPreferencesResponse");
var OrderHistoryReportResponse_1 = require("./OrderHistoryReportResponse");
var UserNotificationResponse_1 = require("./UserNotificationResponse");
/**
 * @export
 */
exports.OrderHistoryItemResponseHcpBillingLabelEnum = {
    Insurance: 'Insurance',
    Institution: 'Institution',
    Patient: 'Patient',
    Other: 'Other'
};
/**
 * @export
 */
exports.OrderHistoryItemResponseHcpStageLabelEnum = {
    Submitted: 'Submitted',
    Received: 'Received',
    Processing: 'Processing',
    Analysis: 'Analysis',
    Complete: 'Complete',
    Cancelled: 'Cancelled'
};
/**
 * @export
 */
exports.OrderHistoryItemResponseHcpTestTypeEnum = {
    Diagnostic: 'Diagnostic',
    Stat: 'STAT',
    Proactive: 'Proactive',
    Exome: 'Exome',
    ExomeAddOn: 'Exome add-on',
    Carrier: 'Carrier',
    Nips: 'NIPS',
    InfertilityCytogenetics: 'Infertility Cytogenetics',
    FollowUpCytogenetics: 'Follow-Up Cytogenetics',
    DevelopmentalDisordersCytogenetics: 'Developmental Disorders (Cytogenetics)'
};
/**
 * @export
 */
exports.OrderHistoryItemResponsePatientResultStatusEnum = {
    GiaInProgress: 'gia_in_progress',
    GiaChatComplete: 'gia_chat_complete',
    GiaCouldNotReach: 'gia_could_not_reach',
    NotInvited: 'not_invited',
    NotScheduled: 'not_scheduled',
    Scheduled: 'scheduled',
    PatientRequested: 'patient_requested',
    Released: 'released',
    Viewed: 'viewed',
    ResultsPending: 'results_pending'
};
/**
 * @export
 */
exports.OrderHistoryItemResponsePatientResultStatusLabelEnum = {
    GiaInProgress: 'Gia: In progress',
    GiaChatComplete: 'Gia: Chat complete',
    GiaCouldNotReach: 'Gia: Could not reach',
    NotInvited: 'Not invited',
    NotScheduled: 'Not scheduled',
    Scheduled: 'Scheduled',
    PatientRequested: 'Patient requested',
    Released: 'Released',
    Viewed: 'Viewed',
    ResultsPending: 'Results pending'
};
/**
 * @export
 */
exports.OrderHistoryItemResponseStageEnum = {
    OrderSubmitted: 'ORDER_SUBMITTED',
    SpecimenReceived: 'SPECIMEN_RECEIVED',
    LabProcessing: 'LAB_PROCESSING',
    AnalysisAndInterpretation: 'ANALYSIS_AND_INTERPRETATION',
    ReportReleased: 'REPORT_RELEASED',
    Cancelled: 'CANCELLED'
};
/**
 * Check if a given object implements the OrderHistoryItemResponse interface.
 */
function instanceOfOrderHistoryItemResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfOrderHistoryItemResponse = instanceOfOrderHistoryItemResponse;
function OrderHistoryItemResponseFromJSON(json) {
    return OrderHistoryItemResponseFromJSONTyped(json, false);
}
exports.OrderHistoryItemResponseFromJSON = OrderHistoryItemResponseFromJSON;
function OrderHistoryItemResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'archived': !(0, runtime_1.exists)(json, 'archived') ? undefined : json['archived'],
        'chartId': !(0, runtime_1.exists)(json, 'chartId') ? undefined : json['chartId'],
        'concepts': !(0, runtime_1.exists)(json, 'concepts') ? undefined : (json['concepts'].map(OrderHistoryConceptResponse_1.OrderHistoryConceptResponseFromJSON)),
        'delegates': !(0, runtime_1.exists)(json, 'delegates') ? undefined : json['delegates'],
        'gcAppointmentStatus': !(0, runtime_1.exists)(json, 'gcAppointmentStatus') ? undefined : json['gcAppointmentStatus'],
        'gcInvitationDates': !(0, runtime_1.exists)(json, 'gcInvitationDates') ? undefined : json['gcInvitationDates'],
        'hasBeenRegistered': !(0, runtime_1.exists)(json, 'hasBeenRegistered') ? undefined : json['hasBeenRegistered'],
        'hasPositiveFinding': !(0, runtime_1.exists)(json, 'hasPositiveFinding') ? undefined : json['hasPositiveFinding'],
        'hasPersonalRisk': !(0, runtime_1.exists)(json, 'hasPersonalRisk') ? undefined : json['hasPersonalRisk'],
        'hcpBillingLabel': !(0, runtime_1.exists)(json, 'hcpBillingLabel') ? undefined : json['hcpBillingLabel'],
        'hcpNotePrefix': !(0, runtime_1.exists)(json, 'hcpNotePrefix') ? undefined : json['hcpNotePrefix'],
        'hcpNoteText': !(0, runtime_1.exists)(json, 'hcpNoteText') ? undefined : json['hcpNoteText'],
        'hcpPreferences': !(0, runtime_1.exists)(json, 'hcpPreferences') ? undefined : (0, OrderHistoryItemHcpPreferencesResponse_1.OrderHistoryItemHcpPreferencesResponseFromJSON)(json['hcpPreferences']),
        'hcpReportReleasedDate': !(0, runtime_1.exists)(json, 'hcpReportReleasedDate') ? undefined : json['hcpReportReleasedDate'],
        'hcpStageLabel': !(0, runtime_1.exists)(json, 'hcpStageLabel') ? undefined : json['hcpStageLabel'],
        'hcpTestType': !(0, runtime_1.exists)(json, 'hcpTestType') ? undefined : json['hcpTestType'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'isCancelled': !(0, runtime_1.exists)(json, 'isCancelled') ? undefined : json['isCancelled'],
        'isRequiresReview': !(0, runtime_1.exists)(json, 'isRequiresReview') ? undefined : json['isRequiresReview'],
        'nonReportAttachmentsSharedWithPhysician': !(0, runtime_1.exists)(json, 'nonReportAttachmentsSharedWithPhysician') ? undefined : json['nonReportAttachmentsSharedWithPhysician'],
        'orderDate': !(0, runtime_1.exists)(json, 'orderDate') ? undefined : json['orderDate'],
        'orderingClinicianFullName': !(0, runtime_1.exists)(json, 'orderingClinicianFullName') ? undefined : json['orderingClinicianFullName'],
        'patientDob': !(0, runtime_1.exists)(json, 'patientDob') ? undefined : json['patientDob'],
        'patientFirstName': !(0, runtime_1.exists)(json, 'patientFirstName') ? undefined : json['patientFirstName'],
        'patientLastName': !(0, runtime_1.exists)(json, 'patientLastName') ? undefined : json['patientLastName'],
        'patientMrn': !(0, runtime_1.exists)(json, 'patientMrn') ? undefined : json['patientMrn'],
        'patientName': !(0, runtime_1.exists)(json, 'patientName') ? undefined : json['patientName'],
        'patientPhoneNumber': !(0, runtime_1.exists)(json, 'patientPhoneNumber') ? undefined : json['patientPhoneNumber'],
        'patientResultStatus': !(0, runtime_1.exists)(json, 'patientResultStatus') ? undefined : json['patientResultStatus'],
        'patientResultStatusLabel': !(0, runtime_1.exists)(json, 'patientResultStatusLabel') ? undefined : json['patientResultStatusLabel'],
        'patientUserEmail': !(0, runtime_1.exists)(json, 'patientUserEmail') ? undefined : json['patientUserEmail'],
        'practiceName': !(0, runtime_1.exists)(json, 'practiceName') ? undefined : json['practiceName'],
        'reports': !(0, runtime_1.exists)(json, 'reports') ? undefined : (json['reports'].map(OrderHistoryReportResponse_1.OrderHistoryReportResponseFromJSON)),
        'reqid': !(0, runtime_1.exists)(json, 'reqid') ? undefined : json['reqid'],
        'sampleReceivedDate': !(0, runtime_1.exists)(json, 'sampleReceivedDate') ? undefined : json['sampleReceivedDate'],
        'stage': !(0, runtime_1.exists)(json, 'stage') ? undefined : json['stage'],
        'turnaroundTime': !(0, runtime_1.exists)(json, 'turnaroundTime') ? undefined : json['turnaroundTime'],
        'unreadCount': !(0, runtime_1.exists)(json, 'unreadCount') ? undefined : json['unreadCount'],
        'userEmail': !(0, runtime_1.exists)(json, 'userEmail') ? undefined : json['userEmail'],
        'userFullName': !(0, runtime_1.exists)(json, 'userFullName') ? undefined : json['userFullName'],
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'userNotificationsByChart': !(0, runtime_1.exists)(json, 'userNotificationsByChart') ? undefined : (json['userNotificationsByChart'].map(UserNotificationResponse_1.UserNotificationResponseFromJSON)),
        'willExpireSoonAt': !(0, runtime_1.exists)(json, 'willExpireSoonAt') ? undefined : json['willExpireSoonAt'],
        'youscriptExpirationDate': !(0, runtime_1.exists)(json, 'youscriptExpirationDate') ? undefined : json['youscriptExpirationDate'],
    };
}
exports.OrderHistoryItemResponseFromJSONTyped = OrderHistoryItemResponseFromJSONTyped;
function OrderHistoryItemResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'archived': value.archived,
        'chartId': value.chartId,
        'concepts': value.concepts === undefined ? undefined : (value.concepts.map(OrderHistoryConceptResponse_1.OrderHistoryConceptResponseToJSON)),
        'delegates': value.delegates,
        'gcAppointmentStatus': value.gcAppointmentStatus,
        'gcInvitationDates': value.gcInvitationDates,
        'hasBeenRegistered': value.hasBeenRegistered,
        'hasPositiveFinding': value.hasPositiveFinding,
        'hasPersonalRisk': value.hasPersonalRisk,
        'hcpBillingLabel': value.hcpBillingLabel,
        'hcpNotePrefix': value.hcpNotePrefix,
        'hcpNoteText': value.hcpNoteText,
        'hcpPreferences': (0, OrderHistoryItemHcpPreferencesResponse_1.OrderHistoryItemHcpPreferencesResponseToJSON)(value.hcpPreferences),
        'hcpReportReleasedDate': value.hcpReportReleasedDate,
        'hcpStageLabel': value.hcpStageLabel,
        'hcpTestType': value.hcpTestType,
        'id': value.id,
        'isCancelled': value.isCancelled,
        'isRequiresReview': value.isRequiresReview,
        'nonReportAttachmentsSharedWithPhysician': value.nonReportAttachmentsSharedWithPhysician,
        'orderDate': value.orderDate,
        'orderingClinicianFullName': value.orderingClinicianFullName,
        'patientDob': value.patientDob,
        'patientFirstName': value.patientFirstName,
        'patientLastName': value.patientLastName,
        'patientMrn': value.patientMrn,
        'patientName': value.patientName,
        'patientPhoneNumber': value.patientPhoneNumber,
        'patientResultStatus': value.patientResultStatus,
        'patientResultStatusLabel': value.patientResultStatusLabel,
        'patientUserEmail': value.patientUserEmail,
        'practiceName': value.practiceName,
        'reports': value.reports === undefined ? undefined : (value.reports.map(OrderHistoryReportResponse_1.OrderHistoryReportResponseToJSON)),
        'reqid': value.reqid,
        'sampleReceivedDate': value.sampleReceivedDate,
        'stage': value.stage,
        'turnaroundTime': value.turnaroundTime,
        'unreadCount': value.unreadCount,
        'userEmail': value.userEmail,
        'userFullName': value.userFullName,
        'userId': value.userId,
        'userNotificationsByChart': value.userNotificationsByChart === undefined ? undefined : (value.userNotificationsByChart.map(UserNotificationResponse_1.UserNotificationResponseToJSON)),
        'willExpireSoonAt': value.willExpireSoonAt,
        'youscriptExpirationDate': value.youscriptExpirationDate,
    };
}
exports.OrderHistoryItemResponseToJSON = OrderHistoryItemResponseToJSON;
